import { Link as MuiLink } from '@mui/material';
import NextLink, { type LinkProps as NextLinkProps } from 'next/link';
import { forwardRef, useMemo } from 'react';

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(function LinkWithHtmlExt(props, ref) {
  const { href, as, replace, scroll, shallow, prefetch, locale, ...other } = props;
  const modifiedAs = useMemo(() => {
    const [path, ...rest] = href.toString().split('?');
    return rest.length === 0 ? `${href}.html` : `${path}.html?${rest}`;
  }, [href]);
  return (
    <NextLink
      href={href}
      prefetch={prefetch}
      as={as || modifiedAs}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      locale={locale}
      ref={ref}
      {...other}
    />
  );
});
interface InternalLinkProps extends NextLinkProps {
  text?: boolean;
  children?: React.ReactNode;
}

export const InternalLink = forwardRef<HTMLAnchorElement, InternalLinkProps>(function NextLinkComposed(props, ref) {
  const { text, ...other } = props;

  if (!text) {
    return <Link ref={ref} {...other} />;
  }
  return <MuiLink component={Link} ref={ref} {...other} sx={{ textDecoration: 'none' }} />;
});
